import { Link } from 'react-router-dom';
import { categories } from '@/mocks/videos';

export default function Footer() {
  return (
    <footer className="bg-background-950 text-background-200">
      <div className="w-full px-4 md:px-6 py-14">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
            <div>
              <Link to="/" className="flex items-center gap-2 mb-4">
                <div className="w-8 h-8 flex items-center justify-center">
                  <i className="ri-play-circle-fill text-2xl" style={{ color: 'oklch(var(--primary-500))' }}></i>
                </div>
                <span className="text-lg font-bold font-heading text-background-50">菠萝视频</span>
              </Link>
              <p className="text-sm text-background-400 leading-relaxed">
                海量高清视频在线观看平台，涵盖电影、电视剧、综艺、动漫等多种类型，随时随地享受优质视频娱乐体验。
              </p>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-background-50 mb-4">视频分类</h4>
              <ul className="space-y-2.5">
                {categories.map((cat) => (
                  <li key={cat.slug}>
                    <Link
                      to={`/category/${cat.slug}`}
                      className="text-sm text-background-400 hover:text-background-100 transition-colors"
                    >
                      {cat.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-background-50 mb-4">快速链接</h4>
              <ul className="space-y-2.5">
                <li>
                  <Link to="/" className="text-sm text-background-400 hover:text-background-100 transition-colors">
                    首页
                  </Link>
                </li>
                <li>
                  <Link to="/about" className="text-sm text-background-400 hover:text-background-100 transition-colors">
                    关于我们
                  </Link>
                </li>
                <li>
                  <a href="#" className="text-sm text-background-400 hover:text-background-100 transition-colors">
                    帮助中心
                  </a>
                </li>
                <li>
                  <a href="#" className="text-sm text-background-400 hover:text-background-100 transition-colors">
                    用户协议
                  </a>
                </li>
                <li>
                  <a href="#" className="text-sm text-background-400 hover:text-background-100 transition-colors">
                    隐私政策
                  </a>
                </li>
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-background-50 mb-4">联系我们</h4>
              <ul className="space-y-2.5">
                <li className="flex items-center gap-2 text-sm text-background-400">
                  <span className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-mail-line"></i>
                  </span>
                  contact@boluovideo.com
                </li>
                <li className="flex items-center gap-2 text-sm text-background-400">
                  <span className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-phone-line"></i>
                  </span>
                  400-888-6666
                </li>
                <li className="flex items-center gap-2 text-sm text-background-400">
                  <span className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-map-pin-line"></i>
                  </span>
                  北京市朝阳区望京SOHO
                </li>
              </ul>
              <div className="flex items-center gap-3 mt-4">
                <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-800 text-background-300 hover:bg-primary-500 hover:text-background-50 transition-colors" aria-label="微信">
                  <i className="ri-wechat-line"></i>
                </a>
                <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-800 text-background-300 hover:bg-primary-500 hover:text-background-50 transition-colors" aria-label="微博">
                  <i className="ri-weibo-line"></i>
                </a>
                <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-800 text-background-300 hover:bg-primary-500 hover:text-background-50 transition-colors" aria-label="抖音">
                  <i className="ri-tiktok-line"></i>
                </a>
                <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-800 text-background-300 hover:bg-primary-500 hover:text-background-50 transition-colors" aria-label="B站">
                  <i className="ri-bilibili-line"></i>
                </a>
              </div>
            </div>
          </div>

          <div className="border-t border-background-800 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-background-500">
              &copy; 2026 菠萝视频 boluovideo.com 版权所有 | 京ICP备2024000001号
            </p>
            <p className="text-xs text-background-500">
              本站内容仅供学习交流使用，请勿用于商业用途
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}